import { useQuery } from '@tanstack/react-query';

import { productApi } from '../api/productApi';

export function useProviderProduct() {
  const { data: providersData, isLoading: isLoadingProviders } = useQuery({
    queryKey: ['providers'],
    queryFn: async () => {
      const data = await productApi.getProviders();

      if (!data) {
        return [];
      }

      return [...data].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
    },
  });

  return {
    providersData,
    isLoadingProviders,
  };
}
